import { motion, AnimatePresence } from "framer-motion";
import { Info, ArrowUp } from "lucide-react";
import Divider from "../divider/Divider";
import Card from "../card/Card";
import SkeletonProdotti from "../skeleton/SkeletonProdotti";
import { saveScrollState, handleProductNavigation } from "../../utils/menuUtils";

export default function MenuProductList({
    products,
    selectedCategory,
    isLoadingProducts,
    strings,
    isSticky,
    showScrollTop,
    categoryScrollRef,
    navigate
}) {
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

    return (
        <>
            <AnimatePresence mode="wait">
                {isLoadingProducts || !selectedCategory ? (
                    <motion.div key="skeleton-prod" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="pt-2">
                        <SkeletonProdotti />
                    </motion.div>
                ) : (
                    <motion.div key={`products-${selectedCategory}`} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }} className="pt-2">
                        {products?.map((item, index) => (
                            <div key={index} className="px-4 py-2">
                                {item?.subcategory && <Divider title={item?.subcategory?.title} />}
                                <div className="flex flex-col gap-3.5 max-w-md mx-auto w-full">
                                    {item?.data?.map((product, idx) => (
                                        <Card
                                            key={idx} title={product.title} image={product.image} price={product.price}
                                            isAvailable={product.available} ingredients={product?.ingredients} type={product.type}
                                            alcoholPercentage={product.alcoholPercentage} quantity={product.quantity} showDetailPage={product.showDetailPage}
                                            onClick={() => {
                                                saveScrollState(selectedCategory, categoryScrollRef.current?.scrollLeft);
                                                handleProductNavigation(product, item.data, idx, navigate);
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Note a piè di pagina */}
            {(strings?.balconcino1 || strings?.balconcinoHeader) && (
                <div className="bg-[#121824] px-5 py-5 mt-8 text-xs text-muted max-w-md mx-auto rounded-2xl border border-accent/20 shadow-inner space-y-1.5 mb-4">
                    <div className="flex items-center gap-2 mb-2">
                        <Info className="w-4 h-4 text-primary shrink-0" />
                        <p className="uppercase font-bold text-secondary tracking-wider text-[10px]">{strings?.balconcinoHeader || "Informazioni"}</p>
                    </div>
                    {strings?.balconcino1 && <p className="leading-relaxed text-muted/90">{strings?.balconcino1}</p>}
                    {strings?.balconcino2 && <p className="leading-relaxed text-muted/90">{strings?.balconcino2}</p>}
                    {strings?.balconcino3 && <p className="leading-relaxed text-muted/90">{strings?.balconcino3}</p>}
                </div>
            )}

            {/* Pulsante Floating Torna Su */}
            {selectedCategory && isSticky && showScrollTop && (
                <button onClick={scrollToTop} aria-label="Torna su" className="fixed bottom-6 right-6 z-50 bg-primary text-black p-3 rounded-xl shadow-xl border border-primary/20 active:scale-95 transition-all duration-200">
                    <ArrowUp className="w-5 h-5 stroke-[2.5]" />
                </button>
            )}
        </>
    );
}